import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import DiscordCallback from "@/pages/DiscordCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Rules from "@/pages/Rules";
import Announcements from "@/pages/Announcements";
import Excuses from "@/pages/Excuses";
import Members from "@/pages/Members";
import Donate from "@/pages/Donate";
import Notifications from "@/pages/Notifications";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import Memurlar from "@/pages/Memurlar";
import IhracEdilenler from "@/pages/IhracEdilenler";
import MemurMazeret from "@/pages/MemurMazeret";
import OlayRaporu from "@/pages/OlayRaporu";
import Mugshot from "@/pages/Mugshot";
import BirimBasvuru from "@/pages/BirimBasvuru";
import MemurBilgi from "@/pages/MemurBilgi";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-black text-zinc-500 font-mono text-sm">
      YÜKLENIYOR...
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/discord/callback" element={<DiscordCallback />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="rules" element={<Rules />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="excuses" element={<Excuses />} />
            <Route path="members" element={<Members />} />
            <Route path="donate" element={<Donate />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="profile" element={<Profile />} />
            <Route path="admin" element={<Admin />} />
            <Route path="memurlar" element={<Memurlar />} />
            <Route path="ihrac-edilenler" element={<IhracEdilenler />} />
            <Route path="memur-mazeret" element={<MemurMazeret />} />
            <Route path="olay-raporu" element={<OlayRaporu />} />
            <Route path="mugshot" element={<Mugshot />} />
            <Route path="birim-basvuru" element={<BirimBasvuru />} />
            <Route path="memur-bilgi" element={<MemurBilgi />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}

export default App;
